import * as React from 'react';
import cx from 'classnames';

import Buttons from 'components/Buttons';
import RemainingCharactersCount from 'chat/components/FullPageComposer/RemainingCharactersCount';

export type Props = {
  className?: string;
  sendButton?: React.ReactElement;
  translateButton: React.ReactElement;
  attachButton?: React.ReactElement;
  scheduleButton?: React.ReactElement;
  charactersRemaining: number;
};

export default class VisualComposerFooter extends React.Component<Props> {
  render() {
    const {
      sendButton,
      translateButton,
      attachButton,
      scheduleButton,
      charactersRemaining,
    } = this.props;

    const remainingCharactersCount = <RemainingCharactersCount count={charactersRemaining} />;

    return (
      <div className={cx('VisualComposerFooter', this.props.className)}>
        <Buttons className="VisualComposerFooter-icons" margin="small">
          {attachButton}
          {translateButton}
          {scheduleButton}
        </Buttons>
        <Buttons margin="medium">
          {remainingCharactersCount}
          {sendButton}
        </Buttons>
      </div>
    );
  }
}
